<template>
  <span id="app" :class="{'mr-3': $mq !== 'lg' }">

    <a
      :href="twitterLink"
      target="_blank"
      class="social_share_link"
      v-if="isEmptyStr($options.filters.translategrader(settings.copy.social_icons_share_twitter, $i18n.locale))"
      >
      <img src="@/assets/img/twitter.svg" height="18" class="pl-1">
    </a>

    <a
      :href="linkedinLink"
      target="_blank"
      class="social_share_link"
      v-if="isEmptyStr($options.filters.translategrader(settings.copy.social_icons_share_linkedin, $i18n.locale))"
      >
      <img src="@/assets/img/linkedin.svg" height="18" class="pl-1">
    </a>

    <a
      :href="facebookLink"
      target="_blank"
      class="social_share_link"
      v-if="isEmptyStr($options.filters.translategrader(settings.copy.social_icons_share_facebook, $i18n.locale))"
      >
      <img src="@/assets/img/facebook.svg" height="18" class="pl-1">
    </a>
  </span>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
    name: 'HeaderSocialIcons',

    computed: {
      ...mapGetters('settings', {
        settings: 'settings'
      }),

      facebookLink : function() {
        var socialLocalTxt = this.$options.filters.translategrader(this.settings.copy.social_icons_share_facebook,this.$i18n.locale);
        return "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(socialLocalTxt)
      },

      linkedinLink : function() {
        var socialLocalTxt = this.$options.filters.translategrader(this.settings.copy.social_icons_share_linkedin,this.$i18n.locale);
        return "https://www.linkedin.com/shareArticle?mini=true&url=" + encodeURIComponent(socialLocalTxt)
      },

      twitterLink : function() {
        var socialLocalTxt = this.$options.filters.translategrader(this.settings.copy.social_icons_share_twitter,this.$i18n.locale);
        return "https://twitter.com/home?status=" + encodeURIComponent(socialLocalTxt)
      }
    },

    methods: {

      isEmptyStr(foo) {
        if( typeof foo === 'undefined' ) {
          return false
        } else {
          if (foo && foo.length > 0) {return true}
          else {return false}
        }
      }
    }
}

</script>

<style scoped>

.social_share_link img{
  margin-top: -8px;
}

.socialSpan {
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderSocialIcons.vue